import MultiSelectPage from "@components/MultiSelectPage"

const OPTIONS = [
  "resistingCravings",
  "stayingMotivated",
  "reducingPortions",
  "knowingWhatToEat",
  "beingTooBusy",
  "somethingElse",
] as const

export default function PastChallenges() {
  return <MultiSelectPage translationKey="pastChallenges" options={OPTIONS} />
}
